module.exports = __webpack_public_path__ + "static/img/btn_Synthesis_2.e4ac04e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/btn_Synthesis_2.png
// module id = farf
// module chunks = 0